import * as types from './mutation-types';

export default {
  [types.SET_APIKEY](state, payload) {
    state.isLogged = false;
    state.apikey = payload.token ? payload.token : payload;

    if (payload && payload.expiredPassword) {
      state.expiredPassword = true;
      state.newPasswordVerificationToken = payload.newPasswordVerificationToken;
    }

    if (payload && payload.rememberMe) state.rememberMe = payload.rememberMe;
    if (state.rememberMe) localStorage.setItem('userInfo', JSON.stringify(state));
  },

  [types.LOG_OUT](state) {
    localStorage.removeItem('userInfo');

    state.account = {};
    state.apikey = '';
    state.isLogged = false;
    state.expiredPassword = false;
    state.newPasswordVerificationToken = null;
  },

  [types.CLEAR_EXPIRED_PASSWORD](state) {
    state.expiredPassword = false;
    state.newPasswordVerificationToken = null;
  },

  [types.SET_USER_INFO](state, user) {
    state.account = user;
    if (state.rememberMe) localStorage.setItem('userInfo', JSON.stringify(state));
  },

  [types.SET_LOGGED_IN](state) {
    state.isLogged = true;
  },
};
